<template>
    <v-container>
        <v-row>
            <v-col
                class="text-center mt-4 pa-0"
            >
                <h1>
                    Recipes
                </h1>
            </v-col>
        </v-row>
        <v-row
            no-gutters
        >
            <Recipes/>
        </v-row>
    </v-container>
</template>

<script>
// @ is an alias to /src
import Recipes from '@/components/menu/Recipes.vue'

export default {
  components: {
    Recipes
  },

  data: () => ({

  }),

  computed: {
     
  }

}
</script>
